import { render, staticRenderFns } from "./Cargar_anexo_membresia.vue?vue&type=template&id=18c83b8c&"
import script from "./Cargar_anexo_membresia.vue?vue&type=script&lang=js&"
export * from "./Cargar_anexo_membresia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports